module.exports = __webpack_public_path__ + "static/Dewaweb-0fc4639e5dc387ff2b306b1606b82956.svg";